const mutation = {
  // 设置购物车数量
  SET_CARTCOUNT: (state, cartCount) => {
    state.cartCount = cartCount
  }
}
export default mutation
